import { LicenseInfo } from "@mui/x-license";

// Use environment variable for safety
const licenseKey = process.env.REACT_APP_MUI_LICENSE_KEY;

// Only set if defined (avoids errors in dev if not yet configured)
if (licenseKey) {
  LicenseInfo.setLicenseKey('e4da5fe28e739ebe5a5df7b9500c8555Tz0xMjA0MDEsRT0xNzkyMDIyMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');
}
